<template>
    <div class="wrapper">
        <div class="live-sinal" v-if="isLive">
            
            <div class="left">
                <span class="first"></span><span class="second"></span><span class="third"></span>正在直播
            </div>
        </div>
        <div class="preview-sinal" v-else>
            <span>直播{{liveTime}}开始</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            heat: {
                type: Number,
                default: 0
            },
            isLive: {
                type: Boolean,
                default: true
            },
            liveTime: {
                type: String,
                default: '10:00'
            }
        }
    }
</script>

<style lang="css" scoped>
.wrapper {
    display: inline-block;
    border-radius: 10px;
    color: #fff;
    font-size: 12px;
    line-height: 20px;
    overflow: hidden;
}
.preview-sinal {
    padding: 0 17px 0 7px;
    background: #595959;
}
.preview-sinal span::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    margin-right: 4px;
    border-radius: 50%;
    background: #fff;
    vertical-align: middle;
}
.left {
    display: inline-block;
    padding: 0 7px;
    background: #932020;
}
.left span {
    display: inline-block;
    width: 3px;
    margin-left: 2px;
    vertical-align: middle;
    background: #fff;
}
.left .first {
    animation: blink 1.5s infinite;
}
.left .second {
    height: 12px;
    animation: blink 1.5s infinite 0.5s;
}
.left .first, .left .third {
    height: 10px;
}
.left .third {
    margin-right: 4px;
    animation: blink 1.5s infinite 1s;
}
.right {
    display: inline-block;
    padding: 0 7px;
    background: #181818;
}
@keyframes blink {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>